import { AppBar, Container, SxProps } from '@mui/material';

import ToolbarLogged from './toolbar-logged/ToolbarLogged';
import ToolbarNotLogged from './ToolbarNotLogged';

const getStyles = (): { [key: string]: SxProps } => {
  return {
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      background: '#fff',
      zIndex: 9,
    },
    container: {
      margin: 0,
    },
  };
};

export interface ToolbarLayoutProps {
  isWithoutSidebar: boolean;
  isUserLogged: boolean;
}

export default function ToolbarLayout(props: ToolbarLayoutProps) {
  const { isWithoutSidebar, isUserLogged } = props;
  const styles = getStyles();

  return (
    <AppBar color="transparent" sx={styles.root} elevation={1}>
      <Container maxWidth="lg" sx={!isWithoutSidebar ? styles.container : {}}>
        {!isUserLogged && <ToolbarNotLogged></ToolbarNotLogged>}
        {isUserLogged && <ToolbarLogged></ToolbarLogged>}
      </Container>
    </AppBar>
  );
}
